module.exports = __webpack_public_path__ + "static/media/youtube.37bf61e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youtube.png
// module id = 346
// module chunks = 0 1 2